import { get, includes } from 'lodash';

import { GEOFENCING_SHOP_TO_COUNTRY_SUPPORT_MAP } from 'constants/geofencing';
import Settings from 'utils/Settings';

class GeofencingUtils {
  static hasCountrySupport(country) {
    const { shopID } = Settings;
    const supportedCountries = get(GEOFENCING_SHOP_TO_COUNTRY_SUPPORT_MAP, shopID, []);

    return includes(supportedCountries, country);
  }
}

export { GeofencingUtils };
